import {
  ThemeModeEnum,
  ScreenResponsivelyType,
  ThemeProviderType
} from '../../../services/themeService/types';
import { getServices } from '../../../infra/startup';
import ThemeInterface from './ThemeInterface';
import { ThemeInterfaceType } from '@clientos/types';
import { internalLogger } from '../clientOsLogger';

let themeInterface: ThemeInterface;

export function getThemeInterface(): ThemeInterface {
  return themeInterface;
}

export default async function initializeThemeInterface(): Promise<ThemeInterfaceType> {
  if (themeInterface) return themeInterface.getInterface();

  const services = getServices();
  const { themeService } = services;

  themeInterface = new ThemeInterface({ themeService });

  return themeInterface.getInterface();
}

export function createNoopThemeInterface(): ThemeInterfaceType {
  return {
    getThemeProviderProperties: function (): ThemeProviderType {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopThemeInterface',
        methodName: 'getThemeProviderProperties()',
        message: 'Noop interface method called - returning empty object'
      });
      return {};
    },
    getScreenResponsivelyProperties: function (): ScreenResponsivelyType {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopThemeInterface',
        methodName: 'getScreenResponsivelyProperties()',
        message: 'Noop interface method called - returning empty object'
      });
      return {};
    },
    getUserThemeMode: function (): ThemeModeEnum {
      /* istanbul ignore next */
      internalLogger?.debug?.d5({
        className: 'createNoopThemeInterface',
        methodName: 'getUserThemeMode()',
        message: 'Noop interface method called - returning light mode'
      });
      return ThemeModeEnum.light;
    }
  };
}
